import { getAuthOptions, API_URL } from './config';

export interface Partner {
    id: string;
    name: string;
    account_count: number;
    last_updated: string;
    created_at: string;
}

export interface SearchResult {
    account_name: string;
    partner_name: string;
    notes: string;
    match_score: number;
}

export async function uploadPartnerData(formData: FormData) {

    // Get auth options but exclude the Content-Type header
    const { headers: { 'Content-Type': _, ...authHeaders }, ...otherAuthOptions } = getAuthOptions();
    
    const response = await fetch(`${API_URL}/admin/partners/upload`, {
        ...otherAuthOptions,
        method: 'POST',
        body: formData,
        headers: {
            ...authHeaders,
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to upload partner data');
    }

    return response.json();
}

export async function searchAccounts(query: string): Promise<SearchResult[]> {
    const response = await fetch(`${API_URL}/accounts/search?q=${encodeURIComponent(query)}`, {
        ...getAuthOptions(),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to search accounts');
    }

    return response.json();
}

export async function getPartnerAnalytics(): Promise<Partner[]> {
    const response = await fetch(`${API_URL}/admin/partners`, {
        ...getAuthOptions(),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to fetch partner analytics');
    }

    return response.json();
}
